<template>
	<div class="pardata_box">
		<div class="data_wrap">
			<ul>
				<li v-for="(v, ind) in objdata" :key="ind" :title="v" v-html="v || ''"></li>
				<li>
					<span v-if="$route.query.typeId != 800">{{ langtrans().sgjjgg[languageIndex] }}{{ def }}</span>
          	<span v-else>服务经过：{{ def }}</span>
				</li>
			</ul>
		</div>
		<div>
			<ul class="gl" v-if="glDataStatus">
				<li>关联案件号：</li>
				<li v-for="(item,index) in glData" class="blue" :class="{'red':item.status}"  @click="topath(item.id,index)">{{ item.caseNo }}</li>
			</ul>
		</div>
<!--    <jianbao style="margin: 20px 0;"></jianbao> -->
	</div>
</template>

<script>
import langtrans from './js/Parinf.vue.trans.js';
import constants from '@/util/constants.js';
import { getCasedetail, connectedCaseList } from '@/views/axios/api.js';
import jianbao from '@/components/par/jianbao'

export default {
	data() {
		let that = this;
		return {
			token:JSON.parse(window.localStorage.getItem('data')).data,
			caseid: this.$route.query.caseid || this.$route.query.id || this.$route.query.caseId,
			obj: {},
			objdata: {},
			acc_list: [],
			checkList: [],
			def: '',
			bid: [],
			inf: null,
			usertype: JSON.parse(window.localStorage.getItem('usertype')).data,
			glData: [],
			glDataStatus: false,
      state:['N/A','待认定','无责','有责']
		};
	},
  components:{
    jianbao
  },
	props: ['dataArr'],
	methods: {
			setTxt(str, status) {
				if (constants.setTxt(str, status)) {
					return constants.setTxt(str, status);
				} else {
					return str;
				}
			},
		langtrans() {
			return langtrans;
		},
		getDetail() {
			var data = {
				token: this.token,
				caseId: this.caseid
			};
			getCasedetail(data)
      .then(data => {
				var data = data.data;
				let addr = '',
					country = '',
					city = '',
					exp = '',
					ssbw = '';
console.log()
         var  reportUser = data.obj.obj.reportUser
         var  reporterContact = data.obj.obj.reporterContact
         var accidentType = data.obj.obj.accidentType
				if (data.obj.generalLocation) {
					if (!this.setTxt(data.obj.generalLocation.addr, 'zh')) {
						addr = data.obj.generalLocation.addr;
					} else {
						addr = this.languageIndex == 0 ? this.setTxt(data.obj.generalLocation.addr, 'zh') : this.setTxt(data.obj.generalLocation.addr, 'en');
					}
				}
				if (data.obj.caseCountry) {
          country = this.languageIndex == 0 ? data.obj.caseCountry : data.obj.caseCountryEn;
				}
				if (data.obj.caseCity) {
					if (this.languageIndex == 0) {
						city = data.obj.caseCity;
					} else {
						city = data.obj.caseCityEn;
					}
				}

				if (data.obj.victimList[0].obj.injuredPart) {
					if (!this.setTxt(data.obj.victimList[0].obj.injuredPart, 'zh')) {
						ssbw = data.obj.victimList[0].obj.injuredPart;
					} else {
						ssbw =
							this.languageIndex == 0
								? this.setTxt(data.obj.victimList[0].obj.injuredPart, 'zh')
								: this.setTxt(data.obj.victimList[0].obj.injuredPart, 'en');
					}
				}
				var type = '';
				if (data.obj.obj.accidentType) {
					type = this.languageIndex == 0 ? data.obj.obj.accidentType : data.obj.obj.accidentTypeEn;
				} else {
					type = '无';
				}
				if (this.setTxt(data.obj.obj.incidentDesc, 'zh')) {
					this.def = this.languageIndex == 0 ? this.setTxt(data.obj.obj.incidentDesc, 'zh') : this.setTxt(data.obj.obj.incidentDesc, 'en');
				} else {
					this.def = this.languageIndex == 0 ? '未填写' : 'None';
				}
        if(this.$route.query.typeId != 800) {
           this.objdata = {
          country: this.langtrans().cxdd[this.languageIndex]+country,
          city: this.langtrans().cxdd1[this.languageIndex]+city,
          addr: this.langtrans().cxdd2[this.languageIndex]+addr,
					type: this.langtrans().sglx[this.languageIndex] + type,
          part:this.langtrans().ssbw[this.languageIndex] + ssbw,
          weather:this.langtrans().tqzh[this.languageIndex] + (data.obj.obj.weatherTag || this.langtrans().wm[this.languageIndex]),
          zeren:'保险责任认证：'+ this.state[data.obj.obj.insuranceLiabilityStatus],
          zerenDef:'保险责任描述：' + (data.obj.obj.insuranceLiabilityStatement ? data.obj.obj.insuranceLiabilityStatement : '无'),
          ddd:'&nbsp;'
				};
        }else {
          console.log( + 'cxsjjcxsjjcxsjjcxsjjcxsjjcxsjj')
          this.objdata = {
          country: this.langtrans().cxdd[this.languageIndex]+country,
          city: this.langtrans().cxdd1[this.languageIndex]+city,
          addr: this.langtrans().cxdd2[this.languageIndex]+addr,
					type: '报案人姓名：' + reportUser,
          part:'报案人电话：'  + reporterContact,
          weather:"服务类型：" + accidentType,
          zeren:'预计上门时间：'+ constants.time(data.obj.obj.incidentTs),
          zerenDef:'&nbsp;',
          // zerenDef:'保险责任描述：' + (data.obj.obj.insuranceLiabilityStatement ? data.obj.obj.insuranceLiabilityStatement : '无'),
          ddd:'&nbsp;'
				};
        }
				
				this.def;
			});

		},
		getglData() {
			var data = {
				token: this.token,
				caseId: this.caseid
			};
			connectedCaseList(data)
				.then(res => {
					console.log(res);
					if (res.data.obj.length == 0) {
						this.glDataStatus = false;
					} else {
						this.glDataStatus = true;
						this.glData = res.data.obj;
            this.this.glData.forEach(item => {
              item.status=0
            })
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
    topath(id,ind){
      var name=this.$route.name;
      this.glData.forEach((item,index) => {
        if(index == ind){
          item.status=1
        }else{
          item.status=0
        }
      })
      this.$router.push({
        name,
        query:{
          typeId:this.$route.query.typeId,
          caseid:id
        }
      })
    }
	},
	computed: {
		languageIndex() {
			return this.$store.state.language;
		}
	},
	mounted() {
      this.getDetail();
		var route = this.$route.fullPath;
		var reg = /commonPage/;
		if (!reg.test(route)) {
			this.getglData();
		}
	},
	watch: {
		languageIndex() {
			this.getDetail();
		},
    '$route.query.caseid'(){
      this.getDetail();
    }
	}
};
</script>

<style scoped>
a {
	text-decoration: none;
	color: #00abfa;
}
.data_wrap {
	width: 100%;
	box-sizing: border-box;
  font-size: 14px;
}
.data_wrap h3 {
	font-size: 18px;
	color: #333;
	margin: 10px 0;
}
.data_wrap ul {
	width: 100%;
	overflow: hidden;
  border-left: 1px solid #d9ddde;
  padding: 0px;
}
.data_wrap ul li {
	line-height: 40px;
	float: left;
  border-bottom: 1px solid #d9ddde;
  border-right: 1px solid #d9ddde;
  padding: 0 5px;
  width: calc(33.3% - 11px);
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.data_wrap ul li:last-child{width: calc(100% - 11px);}
.data_wrap ul li:last-child textarea {
	width: 80%;
	height: 80px;
	border: 0;
	border: 1px solid #d9ddde;
	border-radius: 5px;
	font-size: 15px;
	margin-top: 15px;
}
.data_wrap ul li:last-child span,
.data_wrap ul li:last-child textarea {
	float: left;
}
.req_box > p {
	margin-top: 15px;
	line-height: 45px;
	text-align: left;
}
.box_req ul li b {
	font-size: 14px;
}
.org_box {
	font-size: 16px;
	box-sizing: border-box;
	padding-left: 15px;
}
.org_box p {
	line-height: 40px;
	color: #333;
}
.acc_box {
	box-sizing: border-box;
	padding: 0 20px;
}
.acc_box > p {
	color: #333;
	line-height: 40px;
	font-size: 15px;
}
.acc_box ul li {
	display: inline-block;
	width: 20%;
	text-align: center;
}
.acc_box ul li p {
	text-align: center;
	line-height: 36px;
	height: 36px;
	font-size: 14px;
}
.acc_box ul li img {
	width: 90px;
	height: 120px;
}
.rescue_box {
	box-sizing: border-box;
	padding: 0 20px;
}
.rescue_box > p {
	line-height: 40px;
	font-size: 14px;
}
.res_div {
	position: relative;
	top: 18px;
}
.res_box {
	position: relative;
	top: 20px;
	font-size: 14px;
	color: #999;
}
.el-checkbox-group {
	position: relative;
	box-sizing: border-box;
	padding: 0 15px;
}
.el-checkbox {
	width: 100%;
	margin-bottom: 20px;
}
.el-checkbox + .el-checkbox {
	margin-left: 0;
}
.db_div,
.res_div {
	font-size: 14px;
	color: #333;
}
.db_box {
	font-size: 14px;
	color: #333;
	margin-left: 30px;
}
.db_box b {
	color: #ff7200;
	margin-left: 8px;
}
.upbtn_box {
	text-align: center;
	margin-top: 0;
}
.gl {
	overflow: hidden;
	margin-bottom: 20px;
  margin-top: 10px;
}
.gl li {
	float: left;
	margin-right: 10px;
	line-height: 20px;
}
.blue{color: #11b0fa;cursor: pointer;}
.red{color: red;}
</style>



// WEBPACK FOOTER //
// src/components/par/Parinf.vue